import i18n from 'live/services/i18n'

import _ from 'lodash'
import React, { Component } from 'react'
import { Checkbox } from 'react-bootstrap'
import { OptionContent, ContainerCheckBox } from '../style/style'
import styled from 'styled-components'

type Props = {
    onSelectWellCard: Function,
    geoTable: object,
    typeAsset: TypeAsset,
    selectedName: string
}
type State = {
    description: boolean,
    location: boolean,
    sections: boolean,
    pressures: boolean,
    trajectory: boolean,
    temperatures: boolean,
    lithology: boolean,
    sumAirGap: boolean,
    all: boolean,
    selectedFracturePressure: string,
    selectedPorePressure: string,
    newSections: boolean
}

class WellImportOption extends Component<Props, State> {
    geoTable = this.props.geoTable

    state = {
        description: true,
        location: true,
        sections: true,
        pressures: true,
        trajectory: true,
        temperatures: true,
        lithology: true,
        sumAirGap: true,
        all: true,
        selectedFracturePressure: this.getGeoPressure(),
        selectedPorePressure: this.getPorePressure(),
        newSections: false
    }

    welCardLocal: WellCard = {
        selectedFracturePressure: this.getGeoPressure(),
        selectedPorePressure: this.getPorePressure()
    }

    getGeoPressure() {
        return this.geoTable && this.props.geoTable.fracturePressure && this.props.geoTable.fracturePressure[0]
            ? this.props.geoTable.fracturePressure[0].value
            : ''
    }

    getPorePressure() {
        return this.geoTable && this.props.geoTable.porePressure && this.props.geoTable.porePressure[0]
            ? this.props.geoTable.porePressure[0].value
            : ''
    }

    onCheck = (event: any) => {
        const target = event.target

        const name = target.name

        if (target.checked) this.welCardLocal[name] = true
        else delete this.welCardLocal[name]

        this.setState({ [name]: target.checked, all: this.allOptionsTrue(this.welCardLocal) })
        this.props.onSelectWellCard(this.welCardLocal)
    }

    allOptionsTrue(obj) {
        const object = _.cloneDeep(_.omit(obj, ['selectedFracturePressure', 'selectedPorePressure', 'newSections']))
        if (_.isEmpty(object)) return false

        return Object.keys(object).length === 7 && Object.keys(object).every(prop => !!object[prop])
    }

    onChangeRadio(type, value) {
        if (type == 'fracture') {
            this.setState({ selectedFracturePressure: value })
            this.welCardLocal.selectedFracturePressure = value
        } else {
            this.setState({ selectedPorePressure: value })
            this.welCardLocal.selectedPorePressure = value
        }
        this.props.onSelectWellCard(this.welCardLocal)
    }

    onCheckAll = (event: any) => {
        const target = event.target

        if (target.checked) {
            this.checkAll()
        } else {
            this.welCardLocal = {
                description: false,
                location: false,
                sections: false,
                pressures: false,
                trajectory: false,
                temperatures: false,
                lithology: false,
                sumAirGap: false,
                newSections: false
            }
            this.setState({ ...this.welCardLocal, all: false })
            this.props.onSelectWellCard({})
        }
    }

    checkAll() {
        this.welCardLocal = {
            description: true,
            location: true,
            sections: true,
            pressures: true,
            trajectory: true,
            temperatures: true,
            lithology: true,
            sumAirGap: true,
            selectedFracturePressure: this.getGeoPressure(),
            selectedPorePressure: this.getPorePressure(),
            newSections: false
        }
        this.setState({ ...this.welCardLocal, all: true })
        this.props.onSelectWellCard(this.welCardLocal)
    }

    componentDidMount() {
        this.checkAll()
    }

    render() {
        return (
            <OptionContent>
                {this.props.selectedName && (
                    <StyledDiv>{`${i18n('What data to import from')} "${this.props.selectedName}" ?`}</StyledDiv>
                )}
                {this.props.geoTable && (
                    <ContainerCheckBox>
                        {' '}
                        <Checkbox
                            type="checkbox"
                            className="SelectAll"
                            name="all"
                            checked={this.state.all}
                            onChange={this.onCheckAll}
                        >
                            {' '}
                            {i18n('SelectAll')}{' '}
                        </Checkbox>
                        <Checkbox
                            type="checkbox"
                            name="description"
                            checked={this.state.description}
                            onChange={this.onCheck}
                        >
                            {' '}
                            {i18n('Description')}{' '}
                        </Checkbox>
                        <Checkbox type="checkbox" name="location" checked={this.state.location} onChange={this.onCheck}>
                            {' '}
                            {i18n('Location')}{' '}
                        </Checkbox>
                        <Checkbox type="checkbox" name="sections" checked={this.state.sections} onChange={this.onCheck}>
                            {' '}
                            {i18n('Sections')}{' '}
                        </Checkbox>
                        {this.props.typeAsset === 'well' && (
                            <React.Fragment>
                                <Checkbox
                                    type="checkbox"
                                    name="newSections"
                                    checked={this.state.newSections}
                                    onChange={this.onCheck}
                                    style={{ marginLeft: '18px' }}
                                >
                                    {' '}
                                    {i18n('Overwrite')}{' '}
                                </Checkbox>
                            </React.Fragment>
                        )}
                        {(this.props.geoTable.fracturePressure.length > 0 ||
                            this.props.geoTable.porePressure.length > 0) && (
                            <Checkbox
                                type="checkbox"
                                name="pressures"
                                className="geopressures"
                                checked={this.state.pressures}
                                onChange={this.onCheck}
                            >
                                {' '}
                                {i18n('Geopressures')}{' '}
                                {this.state.pressures && (
                                    <div className="pressuresComp">
                                        {this.props.geoTable.fracturePressure && (
                                            <div onClick={event => event.preventDefault()}>
                                                {i18n('FracturePressure')}{' '}
                                            </div>
                                        )}
                                        {this.props.geoTable.fracturePressure.map((element, key) => {
                                            return (
                                                <div key={key}>
                                                    {element.name && (
                                                        <div>
                                                            <input
                                                                type="radio"
                                                                className="radioImport"
                                                                value={key}
                                                                checked={
                                                                    element.value == this.state.selectedFracturePressure
                                                                }
                                                                onChange={() =>
                                                                    this.onChangeRadio('fracture', element.value)
                                                                }
                                                            />
                                                            <span
                                                                className="nameRadio"
                                                                onClick={event => event.preventDefault()}
                                                            >
                                                                {element.name.replace('Ã¡', 'á').replace('Ã£', 'ã')}{' '}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}
                                        {this.props.geoTable.porePressure && (
                                            <div className="porePressures" onClick={event => event.preventDefault()}>
                                                {i18n('PorePresure')}{' '}
                                            </div>
                                        )}
                                        {this.props.geoTable.porePressure.map((element, key) => {
                                            return (
                                                <div key={key}>
                                                    {element.name && (
                                                        <div>
                                                            <input
                                                                type="radio"
                                                                className="radioImport"
                                                                value={key}
                                                                checked={
                                                                    element.value == this.state.selectedPorePressure
                                                                }
                                                                onChange={() =>
                                                                    this.onChangeRadio('pressure', element.value)
                                                                }
                                                            />
                                                            <span
                                                                className="nameRadio"
                                                                onClick={event => event.preventDefault()}
                                                            >
                                                                {element.name.replace('Ã¡', 'á').replace('Ã£', 'ã')}{' '}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                            </Checkbox>
                        )}
                        <Checkbox
                            type="checkbox"
                            name="trajectory"
                            checked={this.state.trajectory}
                            onChange={this.onCheck}
                        >
                            {' '}
                            {i18n('Trajectory')}{' '}
                        </Checkbox>
                        <Checkbox
                            type="checkbox"
                            name="temperatures"
                            checked={this.state.temperatures}
                            onChange={this.onCheck}
                        >
                            {' '}
                            {i18n('Temperature')}{' '}
                        </Checkbox>
                        <Checkbox
                            type="checkbox"
                            name="lithology"
                            checked={this.state.lithology}
                            onChange={this.onCheck}
                        >
                            {i18n('Lithology')}
                        </Checkbox>
                        <Checkbox
                            type="checkbox"
                            name="sumAirGap"
                            checked={this.state.sumAirGap}
                            onChange={this.onCheck}
                        >
                            {i18n('Sum Air Gap')}
                        </Checkbox>
                    </ContainerCheckBox>
                )}
            </OptionContent>
        )
    }
}

export default WellImportOption

const StyledDiv = styled.div`
    padding: 15px 10px 10px 25px;
    font-size: 13px;
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-family: SourceSansPro-Regular, Arial, "Helvetica Neue", Helvetica, sans-serif;
`
